function setRet(values, cat, key) {
  let ret = '';
  if (cat in values) {
    if (key in values[cat]) {
      ret = values[cat][key];
    }
  }

  return ret;
}

export const bankAccounts = (cat, key) => {
  const values = {
    type: {
      checking: 'Checking',
      savings: 'Savings',
      'money market': 'Money Market',
      cd: 'CD',
    },
  };

  return setRet(values, cat, key);
};

export const nonRetirementAccounts = (cat, key) => {
  const values = {
    type: {
      brokerage: 'Brokerage',
      'mutual fund': 'Mutual Fund',
      stock: 'Stock',
      trust: 'Trust',
      annuity: 'Annuity',
      hsa: 'HSA',
      hsaOther: 'HSA',
      nraOther: 'Other',
    },
  };

  return setRet(values, cat, key);
};

export const personalRetirementAccounts = (cat, key) => {
  const values = {
    type: {
      traditional: 'Traditional',
      roth: 'Roth',
      sep: 'SEP',
      simple: 'Simple',
      inherited: 'Inherited',
      other: 'Other',
    },
  };

  return setRet(values, cat, key);
};

export const employerSponsoredPlans = (cat, key) => {
  const values = {
    type: {
      '401k': '401(k)',
      tsp: 'TSP',
      '403b': '403(b)',
      'profit-sharing': 'Profit Sharing Plan',
      'deferred-compensation': 'Deferred Compensation',
      esop: 'ESOP (employee stock ownership plan)',
      espp: 'ESPP (employee stock purchase plan)',
      rsus: 'RSUs (restricted stock options)',
      sos: 'SOs (stock options)',
      '401a': '401(a)',
      other: 'Other',
    },
  };

  return setRet(values, cat, key);
};

export const lifeInsurancePolicies = (cat, key) => {
  const values = {
    type: {
      term: 'Term',
      whole: 'Whole life',
      universal: 'Universal life',
      variable: 'Variable life',
    },
    mode: {
      annual: 'annual',
      'semi-annual': 'Semi-annual',
      quarterly: 'Quarterly',
      monthly: 'Monthly',
    },
  };

  return setRet(values, cat, key);
};

export const personalAssets = (cat, key) => {
  const values = {
    type: {
      jewelry: 'Jewelry',
      artwork: 'Artwork',
      collectibles: 'Collectibles',
      other: 'Other',
    },
  };

  return setRet(values, cat, key);
};

export const educationAccounts = (cat, key) => {
  const values = {
    type: {
      direct: 'Direct',
      guided: 'Guided',
    },
  };

  return setRet(values, cat, key);
};

export const realAssets = (cat, key) => {
  const values = {
    description: {
      primaryResidence: 'Primary Residence',
      secondaryResidence: 'Secondary Residence',
      land: 'Land',
      rental: 'Rental',
      commercialRental: 'Commercial Rental',
    },
  };

  return setRet(values, cat, key);
};

export const liabilities = (cat, key) => {
  const values = {
    type: {
      mortgage: 'Mortgage',
      heloc: 'HELOC',
      homeEquityLoan: 'Home Equity Loan',
      autoLease: 'Auto Lease',
      studentLoan: 'Student Loan',
      personalLineOfCredit: 'Personal Line of Credit',
      investmentMarginLoan: 'Investment Margin Loan',
      lifeInsurancePolicyLoan: 'Life Insurance Policy Loan',
      retirementPlanLoan: 'Retirement Plan Loan',
      creditCard: 'Credit Card',
      other: 'Other',
    },
    loanType: {
      fixed: 'Fixed',
      adjustable: 'Adjustable',
    },
  };

  return setRet(values, cat, key);
};

export const trusts = (cat, key) => {
  const values = {
    type: {
      revocable: 'Revocable',
      irrevocable: 'Irrevocable',
    },
  };

  return setRet(values, cat, key);
};

export const otherAdvisors = (cat, key) => {
  const values = {
    type: {
      accountant: 'Accountant',
      estatePlanningAttorney: 'Estate Planning Attorney',
      insuranceAgent: 'Insurance Agent',
      otherProfessional: 'Other Professional',
    },
  };

  return setRet(values, cat, key);
};

export const pcInsurancePolicies = (cat, key) => {
  const values = {
    type: {
      auto: 'Auto',
      umbrella: 'Umbrella',
      homeowners: 'Homeowners',
      renters: 'Renters',
      other: 'Other',
    },
  };

  return setRet(values, cat, key);
};

export const healthSavingsAccounts = (cat, key) => {
  const values = {
    fsaType: {
      healthcare: 'Healthcare',
      dependent: 'Dependent',
    },
    hsaType: {
      group: 'Group',
      private: 'Private',
      disabled: 'Disabled',
    },
  };

  return setRet(values, cat, key);
};

export const actionItems = (cat, key) => {
  const values = {
    priority: {
      high: 'High',
      medium: 'Med',
      low: 'Low',
    },
  };

  return setRet(values, cat, key);
};

export const businessInterests = (cat, key) => {
  const values = {
    type: {
      cCorp: 'C Corp',
      sCorp: 'S Corp',
      llc: 'LLC',
      soleProprietor: 'Sole Proprietor',
      other: 'Other',
    },
  };

  return setRet(values, cat, key);
};

export const debts = {
  artwork: 'Artwork',
};

export const questionnaireSectionNotes = (cat, key) => {
  const values = {
    section: {
      accountant: 'Accountant',
      advancedHealthCareDirective: 'Advanced HealthCare Directive',
      bankAccounts: 'Bank Accounts',
      businessOwnerships: 'Business Ownerships',
      children: 'Children',
      contactInfo: 'Contact Info',
      debtPayments: 'Debt Payments',
      definedPensionPlans: 'Defined Pension Plans',
      dependents: 'Dependents',
      educationAccounts: 'Education Accounts',
      employerSponsoredPlans: 'Employer Sponsored Plans',
      employmentInfo: 'Employment Info',
      estatePlanningAttorney: 'Estate Planning Attorney',
      estatePlanningNotes: 'Estate Planning Notes',
      familyDetails: 'Family Details',
      generalPowerOfAttorney: 'General Power Of Attorney',
      giftsToFamily: 'Gifts To Family',
      goalsAndObjectives: 'Goals And Objectives',
      groupDisabilityInsurance: 'Group Disability Insurance',
      groupHealthInsurance: 'Group Health Insurance',
      groupLifeInsurance: 'Group Life Insurance',
      homeRelatedExpenses: 'Home Related Expenses',
      incomeDetails: 'Income Details',
      incomeTaxSummary: 'Income Tax Summary',
      insuranceAgent: 'Insurance Agent',
      investmentKnowledge: 'Investment Knowledge',
      investmentOther: 'Investment Other',
      investmentProfile: 'Investment Profile',
      liabilities: 'Liabilities',
      lifestyleExpenses: 'Lifestyle Expenses',
      longTermCareInsurance: 'Long Term Care Insurance',
      medicareInsurance: 'Medicare Insurance',
      nonRetirementAccounts: 'Non Retirement Accounts',
      notes: 'Notes',
      otherProfessional: 'Other Professional',
      personalAssets: 'Personal Assets',
      personalInfo: 'Personal Info',
      personalInterests: 'Personal Interests',
      personalRetirementAccounts: 'Personal Retirement Accounts',
      privateDisabilityInsurance: 'Private Disability Insurance',
      privateHealthInsurance: 'Private Health Insurance',
      privateLifeInsurance: 'Private Life Insurance',
      properties: 'Properties',
      propertyInsurance: 'Property Insurance',
      savings: 'Savings',
      secondaryIncomeDetails: 'Secondary Income Details',
      significantOtherContactInfo: 'Significant Other Contact Info',
      significantOtherEmploymentInfo: 'Significant Other Employment Info',
      significantOtherPersonalInfo: 'Significant Other Personal Info',
      socialSecurityBenefits: 'Social Security Benefits',
      taxes: 'Taxes',
      transportationExpenses: 'Transportation Expenses',
      trust: 'Trust',
      vehicles: 'Vehicles',
      will: 'Will',
      employeeStockOptions: 'Employee Stock Options',
      healthSavingsAccounts: 'Health Savings Accounts',
      w2IncomeDetailsSection: 'W2 Income Details',
      w2IncomeDetailsSectionSO: 'W2 Income Details',
    },
  };

  return setRet(values, cat, key);
};

export const investableAssets = (cat, key) => {
  if (cat !== 'type') return '';
  switch (key) {
    case 'nonretirement':
      return 'Non-Retirement';
    case 'personalRetirement':
      return 'Personal Retirement';
    case 'bank':
      return 'Bank Account';
    case 'employerRetirement':
      return 'Employer-Sponsored Retirement';
    case 'pension':
      return 'Pension';
    default:
      break;
  }
  let ret = bankAccounts(cat, key);
  if (ret !== '') return ret;
  ret = nonRetirementAccounts(cat, key);
  if (ret !== '') return ret;
  ret = personalRetirementAccounts(cat, key);
  if (ret !== '') return ret;
  ret = employerSponsoredPlans(cat, key);
  if (ret !== '') return ret;
  ret = lifeInsurancePolicies(cat, key);
  return ret;
};

export const supportedPreviewExtensions = [
  'csv',
  'htm',
  'html',
  'json',
  'log',
  'rtf',
  'txt',
  'webdoc',
  'pdf',
  'xhtml',
  'xml',
  'jpeg',
  'jpg',
  'png',
];
